var ezdia;
(function (ezdia) {
    var TEMPLATE = ezdia.templates.pageFiltersAndHeading;
    var CUS_WRAP_ID = ezdia.util.makeId();
    var CUSTOM_DATE = 'custom_date';
    var DATE_FORMAT_VIEW = 'MMM DD, YYYY';
    var DATE_FORMAT_DB = 'YYYY-MM-DD';
    var QUERY_PARAMS_NAMES = {
        DR: 'dateRange',
        FD: 'fromDate',
        TD: 'toDate',
        CFD: 'compareFromDate',
        CTD: 'compareToDate'
    };
    function getIds() {
        return {
            rgComCb: ezdia.util.makeId(),
            rgComInput: ezdia.util.makeId(),
            rgComOpt: ezdia.util.makeId(),
            rgComW: ezdia.util.makeId(),
            rgInput: ezdia.util.makeId(),
            rgW: ezdia.util.makeId(),
            sCb: ezdia.util.makeId(),
            sInput: ezdia.util.makeId()
        };
    }
    function getCustomeDateRangeLabel() {
        var FD = QUERY_PARAMS_NAMES.FD, TD = QUERY_PARAMS_NAMES.TD;
        var _a = __read(ezdia.util.getUrlParams([FD, TD]), 2), fromDate = _a[0], toDate = _a[1];
        var dateArray = [moment(fromDate).format(DATE_FORMAT_VIEW)];
        if (toDate) {
            dateArray.push(moment(toDate).format(DATE_FORMAT_VIEW));
        }
        return "" + dateArray.join(' - ');
    }
    function updateSelNumOfDays(start, end) {
        var id = this.id;
        var days = end.diff(start, 'days') + 1;
        var from = document.getElementById(id + "__days");
        from.innerHTML = days + " " + (days > 1 ? 'days' : 'day');
    }
    function getLastYearDt(dt) {
        var todate = dt;
        if (!dt) {
            todate = moment().format(DATE_FORMAT_DB);
        }
        var _a = __read(todate.split('-'), 3), year = _a[0], month = _a[1], day = _a[2];
        var lastYear = parseInt(year, 10) - 1;
        var lastYearDate = lastYear + "-" + month + "-" + day;
        return lastYearDate;
    }
    function getIsLastYear(dt) {
        var lastYearDate = getLastYearDt(dt);
        var min = $.ezdia.config.pageParams.calendar.min;
        return moment(min).isBefore(lastYearDate);
    }
    function getPrevComDays(start, end) {
        var days = end.diff(start, 'days');
        var subDays = 1000 * 60 * 60 * 24 * (days + 1);
        var startTime = start.valueOf();
        var endTime = end.valueOf();
        var cStartTime = moment(startTime - subDays).format(DATE_FORMAT_DB);
        var cEndTime = moment(endTime - subDays).format(DATE_FORMAT_DB);
        return [cStartTime, cEndTime];
    }
    function setLastYearDt(rgInput, rgComInputElem) {
        var _a = __read(getStartAndEndDt(rgInput), 2), start = _a[0], end = _a[1];
        var startDB = start.format(DATE_FORMAT_DB);
        var endDB = end.format(DATE_FORMAT_DB);
        var lyStart = getLastYearDt(startDB);
        var lyEnd = getLastYearDt(endDB);
        var viewStart = getConfigDateFormat(lyStart);
        var viewEnd = getConfigDateFormat(lyEnd);
        var daterangepicker = rgComInputElem.data('daterangepicker');
        daterangepicker.setStartDate(viewStart);
        daterangepicker.setEndDate(viewEnd);
        updateSelNumOfDays.call(rgComInputElem[0], moment(viewStart, DATE_FORMAT_VIEW), moment(viewEnd, DATE_FORMAT_VIEW));
    }
    function getConfigDateFormat(date) {
        return moment(date, DATE_FORMAT_DB).format(DATE_FORMAT_VIEW);
    }
    function inRangeDt(start, end, dt) {
        var startDates = new Date(start);
        var endDates = new Date(end);
        var date = new Date(dt.toString());
        var inrange = moment(date).isBetween(startDates, endDates) ||
            moment(date).diff(startDates) === 0 ||
            moment(date).diff(endDates) === 0;
        return inrange;
    }
    function getStartAndEndDt(id) {
        var dateRange = document.getElementById("" + id);
        var _a = $(dateRange).data().daterangepicker, startDate = _a.startDate, endDate = _a.endDate;
        return [startDate, endDate];
    }
    function inprogressDtCls(dt) {
        var calendar = $.ezdia.config.pageParams.calendar;
        var inprogressEnd = calendar.in_progress_end, inprogressStart = calendar.in_progress_start;
        var inrange = inRangeDt(inprogressStart, inprogressEnd, dt);
        return inrange ? "in-progress" : "";
    }
    function customCompareDate(dt) {
        var _a = this.data().daterangepicker, startDate = _a.startDate, endDate = _a.endDate;
        var inrange = inRangeDt(startDate, endDate, dt);
        return inrange ? "compare-to" : "";
    }
    function inprogressDt(dt) {
        var calendar = $.ezdia.config.pageParams.calendar;
        var inprogressEnd = calendar.in_progress_end, inprogressStart = calendar.in_progress_start;
        var inrange = inRangeDt(inprogressStart, inprogressEnd, dt);
        return inrange;
    }
    function isCustomDate(inprogressCallback, rangeCallback, dt) {
        var cls;
        if (inprogressCallback) {
            cls = inprogressCallback(dt);
        }
        if (!cls && rangeCallback) {
            cls = rangeCallback(dt);
        }
        return cls;
    }
    function dateRangeEvents(ids, isLastYear) {
        var tab = $.ezdia.config.pageParams.tab;
        var sInput = ids.sInput, rgW = ids.rgW, sCb = ids.sCb, rgInput = ids.rgInput, rgComInput = ids.rgComInput, rgComCb = ids.rgComCb, rgComW = ids.rgComW, rgComOpt = ids.rgComOpt;
        var sDtWrap = document.getElementById(sInput + "__row");
        var mtDtWrap = document.getElementById("" + rgW);
        $("#" + sCb).on('click', function click() {
            var checked = this.checked;
            if (checked) {
                sDtWrap.removeAttribute('hidden');
                mtDtWrap.setAttribute('hidden', 'hidden');
            }
            else {
                mtDtWrap.removeAttribute('hidden');
                sDtWrap.setAttribute('hidden', 'hidden');
            }
        });
        if (tab === 'eza_lists') {
            var calendar = $.ezdia.config.pageParams.calendar;
            var inprogressStart = calendar.in_progress_start;
            var comDtWrap_1 = document.getElementById("" + rgComW);
            var rgComInputElem_1 = $("#" + rgComInput);
            var rgInputElem_1 = $("#" + rgInput);
            var inprogressfn_1;
            var isCustomDatefn_1;
            if (inprogressStart) {
                inprogressfn_1 = inprogressDtCls;
            }
            $("#" + rgComCb).on('click', function click() {
                var checked = this.checked;
                if (checked) {
                    isCustomDatefn_1 = customCompareDate;
                    comDtWrap_1.removeAttribute('hidden');
                }
                else {
                    comDtWrap_1.setAttribute('hidden', 'hidden');
                }
                rgComInputElem_1.data('daterangepicker').isCustomDate = isCustomDate.bind(rgInputElem_1, inprogressfn_1, isCustomDatefn_1.bind(rgInputElem_1));
                rgInputElem_1.data('daterangepicker').isCustomDate = isCustomDate.bind(rgComInputElem_1, inprogressfn_1, isCustomDatefn_1.bind(rgComInputElem_1));
            });
            if (isLastYear) {
                $("#" + rgComOpt).on('change', function click() {
                    var value = this.value;
                    if (value === 'last_year') {
                        setLastYearDt(rgInput, rgComInputElem_1);
                        rgComInputElem_1.attr('readonly', 'readonly');
                        rgComInputElem_1.css('pointer-events', 'none');
                    }
                    else {
                        rgComInputElem_1.removeAttr('readonly');
                        rgComInputElem_1.css('pointer-events', '');
                    }
                });
            }
        }
    }
    function updateCompareDtConfig(rgComOptElem, rgComInputElem, start, end) {
        var $rgComInputElem = $(rgComInputElem);
        var isLastYear = getIsLastYear(start.format(DATE_FORMAT_DB));
        var option = rgComOptElem.querySelector('[value="last_year"]');
        var rgComOptVal = rgComOptElem.value;
        if (isLastYear) {
            option.removeAttribute('disabled');
        }
        else {
            option.setAttribute('disabled', 'disabled');
        }
        if (!isLastYear && rgComOptVal === 'last_year') {
            option.setAttribute('disabled', 'disabled');
            rgComOptElem.value = CUSTOM_DATE;
            $(rgComOptElem).trigger('change');
        }
        else if (rgComOptVal === 'last_year') {
            setLastYearDt(this.id, $rgComInputElem);
        }
        else if (rgComOptVal === CUSTOM_DATE) {
            var _a = __read(getPrevComDays(start, end), 2), cStart = _a[0], cEnd = _a[1];
            var daterangepicker_1 = $rgComInputElem.data('daterangepicker');
            daterangepicker_1.setStartDate(getConfigDateFormat(cStart));
            daterangepicker_1.setEndDate(getConfigDateFormat(cEnd));
            updateSelNumOfDays.call(rgComInputElem, start, end);
        }
        updateSelNumOfDays.call(this, start, end);
    }
    function dateRangeWidgets(ids, isLastYear) {
        var _a = $.ezdia.config.pageParams, calendar = _a.calendar, tab = _a.tab;
        var sInput = ids.sInput, rgInput = ids.rgInput, rgComInput = ids.rgComInput, rgComOpt = ids.rgComOpt;
        var compareFrom = calendar.compare_from, compareTo = calendar.compare_to, from = calendar.from, inprogressStart = calendar.in_progress_start, max = calendar.max, min = calendar.min, to = calendar.to;
        calendar.in_progress_start = '2020-10-1';
        calendar.in_progress_end = '2020-10-10';
        var maxDate = getConfigDateFormat(max) || moment().subtract(1, 'days');
        var dateOptions = {
            autoApply: true,
            startDate: from ? getConfigDateFormat(from) : maxDate,
            endDate: to ? getConfigDateFormat(to) : maxDate,
            minDate: getConfigDateFormat(min),
            maxDate: maxDate,
            locale: {
                format: DATE_FORMAT_VIEW
            }
        };
        if (inprogressStart) {
            dateOptions.isInvalidDate = inprogressDt;
            dateOptions.isCustomDate = inprogressDtCls;
        }
        $("#" + sInput).daterangepicker(__assign({ parentEl: "#" + sInput + "__row", singleDatePicker: true }, dateOptions));
        var rgInputElem = document.getElementById(rgInput);
        var $rgInputElem = $(rgInputElem);
        var isComp = tab === 'eza_lists';
        var rgInputOnUpdateFn = updateSelNumOfDays.bind(rgInputElem);
        /**
         * Compare date
         */
        if (isComp) {
            var rgComInputElem = document.getElementById(rgComInput);
            var $rgComInputElem = $(rgComInputElem);
            var inprogressfn = void 0;
            if (inprogressStart) {
                inprogressfn = inprogressDtCls;
            }
            var compareDatefn = customCompareDate.bind($rgInputElem);
            var startDate = moment(dateOptions.startDate, DATE_FORMAT_VIEW);
            var endDate = moment(dateOptions.endDate, DATE_FORMAT_VIEW);
            var _b = __read(getPrevComDays(startDate, endDate), 2), cStart = _b[0], cEnd = _b[1];
            $rgComInputElem.daterangepicker(__assign(__assign({ parentEl: "#" + rgComInput + "__cal", opens: 'left', isCustomDate: isCustomDate.bind($rgInputElem, inprogressfn, compareDatefn) }, dateOptions), { startDate: getConfigDateFormat(cStart), endDate: getConfigDateFormat(cEnd) }), updateSelNumOfDays.bind(rgComInputElem));
            updateSelNumOfDays.call(rgComInputElem, moment(dateOptions.startDate, DATE_FORMAT_VIEW), moment(dateOptions.endDate, DATE_FORMAT_VIEW));
            var rgComOptElem = document.getElementById(rgComOpt);
            rgInputOnUpdateFn = updateCompareDtConfig.bind(rgInputElem, rgComOptElem, rgComInputElem);
        }
        $rgInputElem.daterangepicker(__assign({ parentEl: "#" + rgInput + "__cal" }, dateOptions), rgInputOnUpdateFn);
        updateSelNumOfDays.call(rgInputElem, moment(dateOptions.startDate, DATE_FORMAT_VIEW), moment(dateOptions.endDate, DATE_FORMAT_VIEW));
    }
    function handelDateRangeApply(dialogBox, ids) {
        var sCb = ids.sCb, sInput = ids.sInput, rgInput = ids.rgInput, rgComCb = ids.rgComCb, rgComInput = ids.rgComInput;
        var tab = $.ezdia.config.pageParams.tab;
        var checkbox = document.getElementById("" + sCb);
        var checked = checkbox.checked;
        var DR = QUERY_PARAMS_NAMES.DR, FD = QUERY_PARAMS_NAMES.FD, TD = QUERY_PARAMS_NAMES.TD, CFD = QUERY_PARAMS_NAMES.CFD, CTD = QUERY_PARAMS_NAMES.CTD;
        var fromDate;
        var toDate;
        var compareFromDate;
        var compareToDate;
        if (checked) {
            var _a = __read(getStartAndEndDt(sInput), 1), startDate = _a[0];
            fromDate = startDate.format(DATE_FORMAT_DB);
            toDate = fromDate;
        }
        else {
            var _b = __read(getStartAndEndDt(rgInput), 2), startDate = _b[0], endDate = _b[1];
            fromDate = startDate.format(DATE_FORMAT_DB);
            toDate = endDate.format(DATE_FORMAT_DB);
            if (tab === 'eza_lists') {
                var comapreCheckbox = document.getElementById("" + rgComCb);
                var isCompareChecked = comapreCheckbox.checked;
                if (isCompareChecked) {
                    var _c = __read(getStartAndEndDt(rgComInput), 2), comparesStartDate = _c[0], comparesEndDate = _c[1];
                    compareFromDate = comparesStartDate.format(DATE_FORMAT_DB);
                    compareToDate = comparesEndDate.format(DATE_FORMAT_DB);
                }
                else {
                    var _d = __read(getPrevComDays(startDate, endDate), 2), cStart = _d[0], cEnd = _d[1];
                    compareFromDate = cStart;
                    compareToDate = cEnd;
                }
            }
        }
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.set(DR, CUSTOM_DATE);
        searchParams.set(FD, fromDate);
        if (toDate) {
            searchParams.set(TD, toDate);
        }
        else {
            searchParams.delete(TD);
        }
        if (compareFromDate) {
            searchParams.set(CFD, compareFromDate);
        }
        else {
            searchParams.delete(CFD);
        }
        if (compareToDate) {
            searchParams.set(CTD, compareToDate);
        }
        else {
            searchParams.delete(CTD);
        }
        window.location.search = searchParams.toString();
    }
    function handelCustomRangeFilert() {
        var tab = $.ezdia.config.pageParams.tab;
        var isLastYear = getIsLastYear();
        var wrapper = ezdia.util.getWrapper(CUS_WRAP_ID);
        var ids = getIds();
        var htmlContent = TEMPLATE.customDateRange(ids, isLastYear);
        var height = tab === 'eza_lists' ? 490 : 400;
        wrapper.html(htmlContent).dialog({
            modal: true,
            title: 'Custom date range',
            width: 600,
            height: height,
            buttons: [
                {
                    text: 'Cancel',
                    class: 'btn-link',
                    click: function () {
                        $(this).dialog('close');
                    }
                },
                {
                    text: 'Apply',
                    class: 'btn-primary',
                    click: function () {
                        handelDateRangeApply(this, ids);
                        $(this).dialog('close');
                    }
                }
            ]
        });
        dateRangeEvents(ids, isLastYear);
        dateRangeWidgets(ids, isLastYear);
    }
    function handelPrimaryFilertOnChange() {
        var value = this.dataset.value;
        if (value === CUSTOM_DATE) {
            handelCustomRangeFilert();
        }
        else {
            var DR = QUERY_PARAMS_NAMES.DR, FD = QUERY_PARAMS_NAMES.FD, TD = QUERY_PARAMS_NAMES.TD, CFD = QUERY_PARAMS_NAMES.CFD, CTD = QUERY_PARAMS_NAMES.CTD;
            var searchParams = new URLSearchParams(window.location.search);
            searchParams.set(DR, value);
            searchParams.delete(FD);
            searchParams.delete(TD);
            searchParams.delete(CFD);
            searchParams.delete(CTD);
            window.location.search = searchParams.toString();
        }
    }
    var PageFiltersAndHeading = /** @class */ (function () {
        function PageFiltersAndHeading() {
        }
        PageFiltersAndHeading.prototype.render = function (props) {
            var _a = ezdia.config.pageParams, account = _a.account, role = _a.role, _b = _a.pageFilters, pageFilters = _b === void 0 ? [] : _b;
            if (!(pageFilters === null || pageFilters === void 0 ? void 0 : pageFilters.length)) {
                return;
            }
            var colModel = [];
            var extPageFilters = $.extend(true, [], pageFilters);
            extPageFilters.forEach(function (column) {
                var name = column.name, config = column.config;
                var value;
                column.id = ezdia.util.makeId();
                if (!config) {
                    column.config = {};
                }
                column.config.blank = false;
                if (name === 'accountName') {
                    // TODO: Make id dynamic but before taht fix all refrence for account value
                    column.id = 'accountName';
                    value = account;
                    column.config.sorting = true;
                }
                else if (name === 'role') {
                    // TODO: Make id dynamic but before taht fix all refrence for role value
                    column.id = 'role';
                    column.config.sorting = true;
                    value = role;
                }
                colModel.push({
                    column: column,
                    value: value
                });
            });
            var htmlContent = TEMPLATE.getMarkup(__assign(__assign({}, props), { pageFilters: colModel }));
            $('#primary-page-header').replaceWith(htmlContent);
            $.ezdia.widgets.renderAll(extPageFilters, 'pagefilter');
            this.events(extPageFilters);
        };
        // eslint-disable-next-line class-methods-use-this
        PageFiltersAndHeading.prototype.renderTitle = function (pageTitle) {
            var htmlContent = TEMPLATE.getPageTitle(pageTitle);
            $('#primary-page-header').replaceWith(htmlContent);
        };
        // eslint-disable-next-line class-methods-use-this
        PageFiltersAndHeading.prototype.dateRange = function () {
            var dateRange = $.ezdia.config.pageParams.dateRange;
            var dateRangeObj = $.ezdia.config.dateRange;
            var $ladel = $('#filter-date-range-ladel');
            if (!dateRange) {
                return;
            }
            var dateText;
            if (dateRange === CUSTOM_DATE) {
                dateText = getCustomeDateRangeLabel();
            }
            else {
                dateText = dateRangeObj[dateRange];
            }
            $ladel.html(dateText);
            var dropdown = $("#filter-date-range-dropdown");
            dropdown.find('li').on('click', handelPrimaryFilertOnChange);
        };
        PageFiltersAndHeading.prototype.events = function (extPageFilters) {
            var self = this;
            extPageFilters.forEach(function (_a) {
                var id = _a.id;
                $("#" + id).on('change', function change() {
                    var _a = this, name = _a.name, value = _a.value;
                    self.loadPage(name, value);
                });
            });
        };
        // eslint-disable-next-line class-methods-use-this
        PageFiltersAndHeading.prototype.loadPage = function (name, value) {
            var _a = ezdia.config.pageParams, _b = _a.pageFilters, pageFilters = _b === void 0 ? [] : _b, userManagement = _a.userManagement, isCreator = _a.isCreator;
            var location = window.location;
            var serachParams = new URLSearchParams(location.search);
            var newSerachParams = new URLSearchParams();
            if (name !== 'accountName') {
                pageFilters.forEach(function (_a) {
                    var filtername = _a.name;
                    var qvalue = serachParams.get(filtername);
                    if (name !== filtername && qvalue) {
                        newSerachParams.set(filtername, qvalue);
                    }
                });
                if (name === 'role') {
                    if (userManagement) {
                        newSerachParams.set(userManagement, userManagement);
                    }
                    if (isCreator) {
                        newSerachParams.set(isCreator, isCreator);
                    }
                }
            }
            newSerachParams.set(name, value);
            location.search = newSerachParams.toString();
        };
        return PageFiltersAndHeading;
    }());
    var component;
    (function (component) {
        component.pageFiltersAndHeading = new PageFiltersAndHeading();
    })(component = ezdia.component || (ezdia.component = {}));
})(ezdia || (ezdia = {}));
